import { call, put, takeLatest } from 'redux-saga/effects';

import { monolithApiUrl } from '../../config/app';
import { ADDED_ADDRESSES_EXPIRATION_TIME_MS } from '../../constants/addressBook';
import { endpoints } from '../../constants/routing';
import {
  IAddBulkOrgAddressesActionPayload,
  IAddOrgAddressActionPayload,
  IEditOrgAddressActionPayload,
} from '../../types/addressBook';
import { IReduxAction } from '../../types/redux';
import * as AddressBookActions from '../actions/addressBook';
import { AuthRequest } from './helpers';

export function* addressBookWorkerSaga(): Generator<any, any, any> {
  try {
    const endpoint = `${monolithApiUrl}${endpoints.getAddressBook}`;

    const response = yield call<any>(AuthRequest, { endpoint });
    if (!response.ok) {
      yield put(AddressBookActions.fetchAddressBookFailure(response.body));
    } else {
      yield put(AddressBookActions.fetchAddressBookSuccess(response.body));
    }
  } catch (error) {
    yield put(AddressBookActions.fetchAddressBookFailure(error));
  }
}

export function* addOrgAddressWorkerSaga(action: IReduxAction<IAddOrgAddressActionPayload>): Generator<any, any, any> {
  const { address, resolve, reject } = action.payload || {};

  try {
    const endpoint = `${monolithApiUrl}${endpoints.createOrgAddress}`;
    const response = yield call<any>(AuthRequest, {
      endpoint,
      method: 'POST',
      body: JSON.stringify({ ...address }),
    });

    if (!response.ok) {
      if (typeof reject === 'function') {
        reject(response.body);
      }
      yield put(AddressBookActions.addOrgAddressFailure(response.body));
    } else {
      if (typeof resolve === 'function') {
        resolve(response.body);
      }
      const expiredAt = Date.now() + ADDED_ADDRESSES_EXPIRATION_TIME_MS;
      yield put(AddressBookActions.addOrgAddressSuccess({ address: { ...address, ...response.body }, expiredAt }));
    }
  } catch (error) {
    if (typeof reject === 'function') {
      reject(error);
    }
    yield put(AddressBookActions.addOrgAddressFailure(error));
  }
}

export function* addBulkOrgAddressesWorkerSaga(
  action: IReduxAction<IAddBulkOrgAddressesActionPayload>,
): Generator<any, any, any> {
  const { addresses, resolve, reject } = action.payload || {};

  try {
    const endpoint = `${monolithApiUrl}${endpoints.createBulkOrgAddresses}`;
    const response = yield call<any>(AuthRequest, {
      endpoint,
      method: 'POST',
      body: JSON.stringify(addresses),
    });

    if (!response.ok) {
      if (typeof reject === 'function') {
        reject(response.body);
      }
      yield put(AddressBookActions.addBulkOrgAddressesFailure(response.body));
    } else {
      if (typeof resolve === 'function') {
        resolve(response.body);
      }
      const expiredAt = Date.now() + ADDED_ADDRESSES_EXPIRATION_TIME_MS;
      yield put(AddressBookActions.addBulkOrgAddressesSuccess({ addresses: response.body, expiredAt }));
    }
  } catch (error) {
    if (typeof reject === 'function') {
      reject(error);
    }
    yield put(AddressBookActions.addBulkOrgAddressesFailure(error));
  }
}

export function* editOrgAddressWorkerSaga(
  action: IReduxAction<IEditOrgAddressActionPayload>,
): Generator<any, any, any> {
  const { address, resolve, reject } = action.payload || {};
  try {
    const endpoint = `${monolithApiUrl}${endpoints.updateOrgAddress}`;
    const response = yield call(AuthRequest, {
      endpoint,
      method: 'PATCH',
      body: JSON.stringify({ ...address }),
    });

    if (!response.ok) {
      if (typeof reject === 'function') {
        reject(response.body);
      }
      yield put(AddressBookActions.editOrgAddressFailure(response.body));
    } else {
      if (typeof resolve === 'function') {
        resolve(response.body);
      }
      yield put(AddressBookActions.editOrgAddressSuccess(address));
    }
  } catch (error) {
    if (typeof reject === 'function') {
      reject(error);
    }
    yield put(AddressBookActions.editOrgAddressFailure(error));
  }
}

const sagas = {
  *watchAddressBookRequest() {
    yield takeLatest(AddressBookActions.FETCH_ADDRESS_BOOK_REQUEST, addressBookWorkerSaga);
  },
  *watchAddOrgAddressRequest() {
    yield takeLatest(AddressBookActions.ADD_ORG_ADDRESS_REQUEST, addOrgAddressWorkerSaga);
  },
  *watchAddBulkOrgAddressesRequest() {
    yield takeLatest(AddressBookActions.ADD_BULK_ORG_ADDRESSES_REQUEST, addBulkOrgAddressesWorkerSaga);
  },
  *watchEditOrgAddressRequest() {
    yield takeLatest(AddressBookActions.EDIT_ORG_ADDRESS_REQUEST, editOrgAddressWorkerSaga);
  },
};

export default sagas;
